import { Avatar } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { revertPositionTitleV2, stringAvatar } from 'shared-utils';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { CompanyDocument, OfflineDriveRoomDocument } from 'types';
import DisplayRoom from '../../DisplayRoom';

const OpportunityCompany = ({
	companyName,
	role,
	logoUrl,
	companyUrl,
	offlineDriveRoom,
	positionLabel,
}: {
	companyName: string;
	role: string;
	logoUrl?: string;
	companyUrl?: string;
	offlineDriveRoom: OfflineDriveRoomDocument;
	positionLabel?: string;
}) => {
	const [avatarImg, setAvatarImg] = useState('');
	const generateAvatar = async (data: CompanyDocument) => {
		const res = await generateCompanyLogoAvatarSrc(data?.logo || '', data?.url || '');
		setAvatarImg(res);
	};

	useEffect(() => {
		generateAvatar({ logo: logoUrl, url: companyUrl } as CompanyDocument);
	}, [logoUrl, companyUrl]);

	return (
		<div className="flex gap-0.5">
			<div className="min-w-[80px] relative rounded-full w-10">
				<Avatar
					rounded
					size="md"
					className="text-xl"
					img={avatarImg}
					placeholderInitials={stringAvatar(companyName?.trim()?.toUpperCase())}
				/>
			</div>
			<div className="flex flex-col">
				<p className="text-[#1C1C28] font-inter text-base font-medium">{companyName}</p>
				<div className="flex flex-col gap-[3px]">
					<p className="text-[#28293D] font-inter text-xs font-medium">
						{revertPositionTitleV2(role)}
						<span>{positionLabel ? ` (${positionLabel})` : ''}</span>
					</p>
					<DisplayRoom offlineDriveRoom={offlineDriveRoom} />
				</div>
			</div>
		</div>
	);
};
export default OpportunityCompany;
